import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 2,
    "name": "Český jazyk",
    "locale": "cs",
    "image": {
      "id": 3,
      "name": "cz.svg",
      "url": "https://api.fervi.selos.cz/files/cz.svg?ai=0",
      "custom_title": "cz",
      "is_ai_generated": false
    },
    "is_default": true
  }
];
